export function Source({ sourceUrls }: { sourceUrls?: string[] }) {
	return (
		<>
			<hr className="my-6 border-gray-100 dark:border-dark-500/50 border-t-2" />
			<div className="div flex space-x-4 text-sm pb-8">
				<h6 className="text-gray-600 mb-3 dark:text-gray-200">
					Source{sourceUrls && sourceUrls.length > 1 && 's'}
				</h6>
				<ul>
          {sourceUrls?.map((sourceUrl, index) => (
            <li>
              <a
              href="https://en.wiktionary.org/wiki/keyboard"
              className="hover:underline hover:text-brand-purple underline cursor-pointer"
            >
              {sourceUrl}
            </a>
            </li>
          ))}
        </ul>
			</div>
		</>
	);
}
